import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border: 1px solid #e6e8f0;
  border-radius: 8px;
  padding: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  &[data-state='empty'] {
    row-gap: 8px;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;
`;

export const Counter = styled.div`
  display: flex;
  height: 22px;
  background-color: #edeff4;
  border-radius: 4px;
  padding: 0px 6px;

  font-size: 14px;
  font-weight: 600;
  color: #474d66;
`;

export const CounterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
`;

const BaseText = styled.p`
  margin: 0;
`;
export const Description = styled(BaseText)`
  font-size: 12px;
  color: #474d66;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const Head = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  &.icons {
    gap: 16px;
  }
`;

export const Line = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
  margin-top: 4px;
  margin-bottom: 4px;
`;

export const CustomScroll = styled.div`
  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Items = styled(CustomScroll)`
  overflow-y: auto;
  overflow-x: hidden;
  flex-grow: 1;
`;
